
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"14","viewBox":"-192 0 512 512","width":"14","xmlns":"http://www.w3.org/2000/svg","fill":"#333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M128 256c0 35.348-28.652 64-64 64S0 291.348 0 256s28.652-64 64-64 64 28.652 64 64zm0 0M128 64c0 35.348-28.652 64-64 64S0 99.348 0 64 28.652 0 64 0s64 28.652 64 64zm0 0M128 448c0 35.348-28.652 64-64 64S0 483.348 0 448s28.652-64 64-64 64 28.652 64 64zm0 0"}})])
          )
        }
      }
    